<div class="profile-panel">
    <div class="profile-identity d-flex align-items-center">
        <div class="profile-avatar">{{ initials }}</div>
        <div>
            <h2 class="profile-name">{{ user?.firstName }} {{ user?.lastName }}</h2>
            <div class="profile-meta">{{ user?.email }}</div>
        </div>
    </div>

    <cdss-pill-tabs class="profile-tabs" [tabs]="tabs" [activeId]="activeTab" (activeIdChange)="activeTab = $event"></cdss-pill-tabs>

    <!-- Both bodies stay mounted so a half-typed form survives switching tabs. -->
    <div class="profile-body" [hidden]="activeTab !== 1">
        <personal-info [user]="user"></personal-info>
    </div>
    <div class="profile-body" [hidden]="activeTab !== 2">
        <change-password></change-password>
    </div>
</div>
